import React from 'react'
import {
    Container,
    Typography,
    Box,
    Paper,
    List,
    ListItem,
    ListItemText,
    Link,
    Divider,
    Grid,
    Card,
    CardContent,
} from '@mui/material'

const weatherData = [
    {
        point: 'Puerto de Colonia',
        longitude: '-57.842943',
        latitude: '-34.476074',
    },
    {
        point: 'Puerto de Juan Lacaze',
        longitude: '-57.445008',
        latitude: '-34.440722',
    },
    {
        point: 'Faro Boca de Cufré',
        longitude: '-57.153108',
        latitude: '-34.450082',
    },
    { point: 'Playa Kiyú', longitude: '-56.727563', latitude: '-34.701704' },
    {
        point: 'Desembocadura del Río Santa Lucía',
        longitude: '-56.4768',
        latitude: '-34.8755',
    },
    {
        point: 'Puerto de Montevideo',
        longitude: '-56.22263',
        latitude: '-34.913407',
    },
    {
        point: 'Isla de Flores',
        longitude: '-55.932172',
        latitude: '-34.944182',
    },
    { point: 'Pontón Recalada', longitude: '-55.85', latitude: '-35.033333' },
    {
        point: 'Puerto de Piriápolis',
        longitude: '-55.281428',
        latitude: '-34.877011',
    },
    {
        point: 'Puerto de Punta del Este',
        longitude: '-54.950936',
        latitude: '-34.963938',
    },
    {
        point: 'Boya José Ignacio',
        longitude: '-54.701944',
        latitude: '-34.884722',
    },
    {
        point: 'Puerto La Paloma',
        longitude: '-54.143056',
        latitude: '-34.653611',
    },
    {
        point: 'Faro Cabo Polonio',
        longitude: '-53.777231',
        latitude: '-34.405727',
    },
    {
        point: 'Faro Punta Palmar',
        longitude: '-53.550835',
        latitude: '-34.066773',
    },
    {
        point: 'Barra del Chuy',
        longitude: '-53.370409',
        latitude: '-33.744357',
    },
]

const ReferenciasMarino = () => {
    return (
        <Container maxWidth="md">
            <Box my={4}>
                <Typography variant="h4" component="h1" gutterBottom>
                    Referencias Pronóstico Marino
                </Typography>
                <Typography variant="body1" paragraph>
                    El nuevo formato del Pronóstico ofrecido por el Instituto
                    Uruguayo de Meteorología (Inumet), busca presentar
                    información meteorológica a los navegantes, en una interfaz
                    sencilla y amigable, combinando tecnologías y herramientas
                    de modelación numérica de predicción con la expertise del
                    equipo de meteorólogos del instituto.
                </Typography>
                <Typography variant="body1" paragraph>
                    Se utilizan dos modelos en la elaboración de los mapas y
                    meteorogramas:
                </Typography>
                <Paper elevation={3} sx={{ my: 2, p: 2 }}>
                    <Typography variant="h6" component="h2" gutterBottom>
                        GFS (Global Forecast System)
                    </Typography>
                    <Typography variant="body2" component="div">
                        <List>
                            <ListItem>
                                <ListItemText primary="Frecuencia de actualización: 4 veces al día (00:00, 06:00, 12:00 y 18:00 UTC)" />
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="Período de pronóstico: 72 horas" />
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="Resolución espacial: 0.25° (aproximadamente 27 x 27 km)" />
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="Cobertura utilizada: 29°S a 38°S y 60°W a 45°W (área del mapa)" />
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="Variables pronosticadas:" />
                                <List>
                                    <ListItem>
                                        <ListItemText primary="Ráfagas: intensidad y dirección (nudos y grados)" />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText primary="Precipitación (mm)" />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText primary="Presión atmosférica a nivel del mar (hPa)" />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText primary="Cobertura total de nubes (%)" />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText primary="Temperatura superficie del mar (°C)" />
                                    </ListItem>
                                </List>
                            </ListItem>
                        </List>
                    </Typography>
                </Paper>
                <Paper elevation={3} sx={{ my: 2, p: 2 }}>
                    <Typography variant="h6" component="h2" gutterBottom>
                        GFS Wave
                    </Typography>
                    <Typography variant="body2" component="div">
                        Es la implementación del modelo GFS con un modelo de
                        olas de tercera generación WAVEWATCH III de NCEP/NOAA.
                        El dominio permite representar la generación y
                        propagación del oleaje en los océanos. En este producto
                        se busca la representación del océano Atlántico Sur
                        (adyacente al territorio uruguayo) y Río de la Plata.
                        <List>
                            <ListItem>
                                <ListItemText primary="Frecuencia de actualización: 4 veces al día (00:00, 06:00, 12:00 y 18:00 UTC)" />
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="Período de pronóstico: 72 horas" />
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="Resolución espacial: 0.25° (aproximadamente 27 x 27 km)" />
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="Cobertura utilizada: 29°S a 38°S y 60°W a 45°W (área del mapa)" />
                            </ListItem>
                            <ListItem>
                                <ListItemText primary="Variables pronosticadas:" />
                                <List>
                                    <ListItem>
                                        <ListItemText primary="Viento: intensidad y dirección (nudos y grados)" />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText primary="Altura de olas (m)" />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText primary="Período de olas (s)" />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText primary="Dirección de olas (grados)" />
                                    </ListItem>
                                </List>
                            </ListItem>
                        </List>
                    </Typography>
                </Paper>
                <Typography variant="body2" paragraph>
                    Los productos provenientes de los modelos se encuentran
                    disponibles estimativamente a las H + 5 horas, por ejemplo,
                    la inicialización de las 06:00 UTC estará disponible en la
                    web a las 11:00 UTC (hora local 08:00 h).
                </Typography>
                <Typography variant="body2" paragraph>
                    La Situación Sinóptica en superficie y Avisos se
                    actualizarán 4 veces al día, en los siguientes horarios: 00,
                    06, 12 y 18 hora local (03, 09, 15 y 21 horario UTC).
                </Typography>
                <Divider sx={{ my: 3 }} />
                <Typography variant="h6" component="h3" gutterBottom>
                    Coordenadas geográficas puntos meteograma
                </Typography>
                <Grid container spacing={2}>
                    {weatherData.map((data, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <Card>
                                <CardContent>
                                    <Typography variant="body1">
                                        <strong>{data.point}</strong>
                                    </Typography>
                                    <Typography variant="body2">
                                        Longitud: {data.longitude}
                                    </Typography>
                                    <Typography variant="body2">
                                        Latitud: {data.latitude}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
                <Divider sx={{ my: 3 }} />
                <Typography variant="body1" paragraph>
                    Más información:{' '}
                    <Link
                        href="https://www.ncei.noaa.gov/products/weather-climate-models/global-forecast"
                        target="_blank"
                        rel="noopener"
                    >
                        https://www.ncei.noaa.gov/products/weather-climate-models/global-forecast
                    </Link>
                </Typography>
                <Typography variant="body1" paragraph>
                    Por consultas, comunicarse vía email a:{' '}
                    <Link href="mailto:contacto@inumet.gub.uy">
                        contacto@inumet.gub.uy
                    </Link>
                </Typography>
            </Box>
        </Container>
    )
}

export default ReferenciasMarino
